import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Overline, Tag, Disclaimer } from "../components/shared";
import { Loader2, Scale } from "lucide-react";

const ROWS = [
  ["formation", "Company Formation"],
  ["token_issuance", "Token Issuance"],
  ["licensing", "Licensing"],
  ["vasp", "VASP Regime"],
  ["securities", "Securities Considerations"],
  ["tax", "Taxation (high level)"],
  ["kyc", "KYC / AML"],
  ["banking", "Banking"],
  ["restrictions", "Investor Restrictions"],
  ["complexity", "Operational Complexity"],
  ["credibility", "Perceived Credibility"],
  ["cost", "Cost Category"],
  ["setup", "Setup Complexity"],
];

export default function Jurisdictions() {
  const [jur, setJur] = useState(null);

  useEffect(() => { api.get("/jurisdictions").then((r) => setJur(r.data.jurisdictions)); }, []);
  if (!jur) return <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;

  return (
    <div className="space-y-5 fade-up" data-testid="jurisdictions-page">
      <div><Overline>Regulatory Research</Overline><h1 className="font-heading font-extrabold text-3xl tracking-tight mt-1">Jurisdiction Comparison</h1></div>
      <Disclaimer>Regulatory information is provided for research purposes and does not constitute legal advice.</Disclaimer>

      <div className="bg-card border border-border/60 overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="text-left px-4 py-3 overline text-muted-foreground sticky left-0 bg-muted/50 min-w-[190px]">Criterion</th>
              {jur.map((j) => (
                <th key={j.id} className="text-left px-4 py-3 min-w-[170px]">
                  <div className="inline-flex items-center gap-2 font-heading font-bold"><Scale className="w-4 h-4 text-primary" />{j.name}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([key, label]) => (
              <tr key={key} className="border-b border-border/40">
                <td className="px-4 py-2.5 font-medium text-muted-foreground sticky left-0 bg-card">{label}</td>
                {jur.map((j) => (
                  <td key={j.id} className="px-4 py-2.5">
                    {["credibility", "complexity", "setup", "cost"].includes(key) ? <Tag>{j[key]}</Tag> : <span className="text-xs">{j[key]}</span>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
